<script setup lang="ts">
import { onMounted, computed, onUnmounted, defineProps } from 'vue'
import MinimalHeader from '@/components/MinimalHeader.vue'
import BaseButton from '@/components/ui/button/BaseButton.vue'
import { type InvitePageContent } from '@/assets/ts/pages/invite'
import { getMcrRootUrl } from '@/lib/siteBaseUrl'
import { createGAEvent, GaGeneralEvent } from '@/assets/ts/customEvent'
import { getCurrentGaPageName } from '@/lib/utils'

const props = defineProps<{
	content: InvitePageContent
}>()

const displayedWelcomeText = computed(() => {
	return props.content.inviteSuccessContent.welcomeText.replace(
		'{USERNAME}',
		window.BUYANDSHIP.settings.user_full_name,
	)
})

const displayedInviteSuccessTitle = computed(() => {
	const welcomeCredit = window.BUYANDSHIP.settings.member_welcome_credits

	return props.content.inviteSuccessContent.title.replace(
		'{WELCOME_CREDIT}',
		String(welcomeCredit),
	)
})

const openAppDownloadPage = () => {
	createGAEvent(GaGeneralEvent.ButtonClick, {
		page_name: getCurrentGaPageName(),
		button_name: 'Download App',
	})

	const downloadAppUrl = 'https://qr.page/g/tSLYydLM2e'

	// Use noreferrer to bypass the QR code's direct linking prohibition
	window.open(downloadAppUrl, '_blank', 'noreferrer, noopener')
}

const goToMCRAccountPage = () => {
	createGAEvent(GaGeneralEvent.ButtonClick, {
		page_name: getCurrentGaPageName(),
		button_name: 'Continue to Website',
	})

	window.location.href = `${getMcrRootUrl()}/account/`
}

const clearInviteSuccessFlag = () => {
	localStorage.removeItem('show_invite_success_page')
}

onMounted(() => {
	window.addEventListener('beforeunload', clearInviteSuccessFlag)
})

onUnmounted(() => {
	window.removeEventListener('beforeunload', clearInviteSuccessFlag)
})
</script>

<template>
	<div class="text-n-950">
		<MinimalHeader />

		<section class="bs-container py-acquaintances">
			<div
				class="col-span-12 flex flex-col items-center gap-casual-friends text-center"
			>
				<div
					class="success-hero-bg h-[229px] w-[304px] bg-cover bg-center mdp:h-[263px] mdp:w-[350px]"
				></div>

				<div class="typography-h4-str text-o-500">
					{{ displayedWelcomeText }}
				</div>

				<div class="max-w-[560px] space-y-close-friends">
					<div class="typography-h2-str">
						{{ displayedInviteSuccessTitle }}
					</div>

					<div class="typography-s1-reg text-n-500">
						{{ content.inviteSuccessContent.description }}
					</div>
				</div>

				<div
					class="flex w-full flex-col gap-16px mdp:max-w-[500px] mdp:flex-row-reverse"
				>
					<BaseButton
						class="w-full"
						variant="primary"
						size="large"
						@click="openAppDownloadPage"
					>
						{{ content.inviteSuccessContent.ctaButtonPrimary }}
					</BaseButton>

					<BaseButton
						class="w-full"
						variant="secondary"
						size="large"
						@click="goToMCRAccountPage"
					>
						{{ content.inviteSuccessContent.ctaButtonSecondary }}
					</BaseButton>
				</div>
			</div>
		</section>
	</div>
</template>
